//React
import * as React from 'react';

import HTMLWidget from '../widgets/HTMLWidget';
import IFrameWidget from '../widgets/IFrameWidget';
import AccordionWidget from '../widgets/AccordionWidget';
import ComplaintWidget from '../widgets/ComplaintWidget';
import TabLinkWidget from '../widgets/TabLinkWidget';
import DebugWidget from '../widgets/DebugWidget';
import { DateProvider } from "../widgets/DateContext";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SliderWidget from '../widgets/SliderWidget';
import MobileComplaintWidget from '../widgets/MobileComplaintWidget';


function fRenderWidget(sSystemName, cWidget, acWidgetLibrary, pSetCurrentTab)
{
    //Get Layout CSS
    var cLayoutCSS;
    if(cWidget.sLayout == "absolute")
    {
        cLayoutCSS = {
            position: "absolute",
            left: cWidget.iOriginX,
            top: cWidget.iOriginY,
            width: cWidget.iWidth,
            height: cWidget.iHeight
        };
    }
    else if(cWidget.sLayout == "solo")
    {
        cLayoutCSS = {
            position: "absolute",
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: "hidden"
        }
    }
    else if(cWidget.sLayout == "sewer")
    {
        let iScreenHeight = window.innerHeight;

        cLayoutCSS = {
            position: "relative",
            display: "flex",
            flexFlow: "column",
            left: cWidget.sMargin,
            width: "calc(100% - " + cWidget.sMargin + " - " + cWidget.sMargin + ")",
            height: (cWidget.flHeight * iScreenHeight),
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_20x20")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 5) + "%",
            top: (cWidget.iGridY * 5) + "%",
            width: (cWidget.iSizeX * 5) + "%",
            height: (cWidget.iSizeY * 5) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_10x10")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 10) + "%",
            top: (cWidget.iGridY * 10) + "%",
            width: (cWidget.iSizeX * 10) + "%",
            height: (cWidget.iSizeY * 10) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_10x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 10) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 10) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_6x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 16.66667) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 16.66667) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_5x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 20) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 20) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_4x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 25) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 25) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_3x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 33.33333) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 33.33333) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_2x2")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 50) + "%",
            top: (cWidget.iGridY * 50) + "%",
            width: (cWidget.iSizeX * 50) + "%",
            height: (cWidget.iSizeY * 50) + "%",
            overflow: "hidden"
        };
    }
    else if(cWidget.sLayout == "grid_2x1")
    {
        cLayoutCSS = {
            position: "absolute",
            left: (cWidget.iGridX * 50) + "%",
            top: (cWidget.iGridY * 100) + "%",
            width: (cWidget.iSizeX * 50) + "%",
            height: (cWidget.iSizeY * 100) + "%",
            overflow: "hidden"
        };
    }
    else
    {
        cLayoutCSS = {
            border: "black dashed 2px",
            background: "purple"
        };
    }

    if(cWidget.bAllowOverflow)
    {
        cLayoutCSS.overflow = 'auto';
    }

    //Lookup Widget
    var cWidgetTemplate = acWidgetLibrary.find(c => c.sName === cWidget.sWidget);

    if(cWidgetTemplate)
    {
        if(cWidget.bDisabled)
        {
            return "";
        }
        else if(cWidgetTemplate.sClass === 'IFrameWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><IFrameWidget sSystemName={sSystemName} cMake={cWidgetTemplate}/></div>
        }
        else if(cWidgetTemplate.sClass === 'HTMLWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><HTMLWidget sSystemName={sSystemName} cMake={cWidgetTemplate} pSetCurrentTab={pSetCurrentTab}/></div>
        }
        else if(cWidgetTemplate.sClass ===  'AccordionWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><AccordionWidget sSystemName={sSystemName} cMake={cWidgetTemplate}/></div>
        }
        else if(cWidgetTemplate.sClass === 'ComplaintWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><ComplaintWidget sSystemName={sSystemName}/></div>
        }
        else if(cWidgetTemplate.sClass === 'MobileComplaintWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><MobileComplaintWidget sSystemName={sSystemName}/></div>
        }
        else if(cWidgetTemplate.sClass === 'TabLinkWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><TabLinkWidget sSystemName={sSystemName} cMake={cWidgetTemplate} pSetCurrentTab={pSetCurrentTab} /></div>
        }
        else if(cWidgetTemplate.sClass === 'DebugWidget')
        {
            return <DebugWidget cMake={cWidgetTemplate}/>
        }
        else if(cWidgetTemplate.sClass === 'SliderWidget')
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateProvider>
                            <SliderWidget sSystemName={sSystemName} cMake={cWidgetTemplate}/>
                        </DateProvider>
                        </LocalizationProvider>
                    </div>
        }
        else
        {
            return <div id={cWidgetTemplate.sName} style={cLayoutCSS}><h2>{"ERROR: No widget class for->" + cWidgetTemplate.sClass}</h2></div>
        }
    }
    else
    {
        return <div id={cWidget.sName} style={cLayoutCSS}><h2>{"ERROR: No widget definition for->" + cWidget.sName}</h2></div>
    }
}

function PortalEngine({sSystemName, cPortal, pSetCurrentTab})
{
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    return (
        <div id={'portal_' + cPortal.sName}>
            {
                cPortal.acWidgets.map(cWidget => 
                (
                    fRenderWidget(sSystemName, cWidget, systemConfig.Widgets, pSetCurrentTab)
                ))
            }
        </div>
    );
}

export default PortalEngine